<template>
	<div>
		<div class="container">
			<div class="app-container">
				<div class="calendar-section">
					<el-config-provider :locale="locale">
						<el-calendar v-model="value" ref="calendar" first-day-of-week='2'>
							<template #dateCell="{ data }">
								<div class="custom-cell">
									<div :class="isToday(data) ? 'current-day' : ''" class="cur-date">
										{{ data.day.split('-').slice(2).join('-') }}
										<!-- slice(1)  是月和日-->
									</div>
									<div class="add-reminder-btn" @click="openAddReminderModal(data)">
										<i class="el-icon-alarm-clock"></i>
									</div>
									<div v-if="hasReminders(data)" class="reminder-indicator"
										@click="openAddReminderModal(data)"><i class="el-icon-alarm-clock"></i></div>
								</div>
							</template>
						</el-calendar>
					</el-config-provider>
				</div>
				<div class="reminders-section">
					<div class="section-title">
						<i class="el-icon-alarm-clock"></i> 提醒事项
						<span style="font-size: 14px; margin-left: 10px; color: #95a5a6;">
							({{ filteredReminders.length }})
						</span>
					</div>

					<div class="reminders-list">
						<div v-if="filteredReminders.length === 0" class="no-reminders">
							<i class="el-icon-bell"></i>
							<h3>暂无提醒事项</h3>
							<p>点击日历中的日期添加提醒</p>
						</div>

						<div v-for="(item, index) in filteredReminders" :key="index" class="reminder-card">
							<div class="reminder-title" @click="gotoCustomerDetail(item.phone)">{{ item.name }} {{ item.phone }}</div>
							<div class="reminder-time">
								<i class="el-icon-time"></i>{{ formatDate(item.date) }} {{item.time }}
							</div>
							<div class="reminder-desc">{{ item.remark }}</div>
							<div class="reminder-actions">
								<i class="el-icon-delete delete-btn" @click="deleteReminder(item.id)"></i>
							</div>
						</div>
					</div>

					<button class="add-btn" @click="openAddReminderModal()" :class="[theme]">
						<i class="el-icon-plus"></i> 添加新提醒
					</button>
				</div>
			</div>
		</div>

		<!-- 添加/编辑提醒模态框 -->
		<el-dialog :title="isEditing ? '编辑提醒' : '添加提醒'" v-model="showReminderModal" width="500px"
			:close-on-click-modal="false">
			<el-form :model="currentReminder" ref="currentReminder" label-width="80px">
				<el-form-item label="手机号" prop="phone">
					<el-input size="small" v-model="currentReminder.phone" placeholder="请输入手机号码"></el-input>
				</el-form-item>
				<el-form-item label="姓名" prop="name">
					<el-input size="small" v-model="currentReminder.name" placeholder="输入提醒姓名"></el-input>
				</el-form-item>
				<el-form-item label="日期" prop="date">
					<el-date-picker size="small" v-model="currentReminder.date" type="date" placeholder="选择日期"
						value-format="yyyy-MM-dd" style="width: 100%;">
					</el-date-picker>
				</el-form-item>
				<el-form-item label="时间" prop="time">
					<el-time-picker size="small" v-model="currentReminder.time" format="HH:mm:ss" placeholder="选择任意时间"
						style="width: 100%;">
					</el-time-picker>
				</el-form-item>
				<el-form-item label="描述" prop="remark">
					<el-input size="small" type="textarea" :rows="3" v-model="currentReminder.remark"
						placeholder="输入提醒详细描述">
					</el-input>
				</el-form-item>
				<el-form-item class="dis-end">
					<el-button @click="closeShowReminderModal">取消</el-button>
					<el-button type="primary" @click="saveReminder" :class="[theme]">添加</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<!-- 通知组件 -->
		<div class="notification" :class="[notification.type, { show: showNotification }]">
			<i :class="notification.icon"></i>
			<i class="el-icon-close" style="color: #ccc;font-size: 22px;position: absolute;top:4px;right: -20px;"
				@click="closeShowNotification"></i>
			<div class="notification-content">
				<h4>{{ notification.name }}</h4>
				<h4>{{ notification.phone }}</h4>
				<p>{{ notification.message }}</p>
			</div>
		</div>

		<el-dialog v-model="dialogIntention" :show-close="false" :close-on-click-modal="false" width="600px"
			draggable>
			<div class="dialog-title">
				<i class="el-icon-s-custom"></i>
				<div class="title" v-if="callStatus == false">
					正在与
					<img src="../../assets/img/phone.png" alt="" />
					&nbsp;{{ phoneNumber }}&nbsp;通话中...
				</div>
				<div class="title" v-else>
					与&nbsp;
					<img src="../../assets/img/phone.png" alt="" />
					{{ phoneNumber }}&nbsp;通话结束
				</div>
				<div class="time">通话时长&nbsp;{{ formatSeconds(callDuration) }}</div>
			</div>
			<div style="overflow: hidden;">
				<div class="info-right">
					<el-form :model="formIntention" ref="form" label-width="110px">
						<el-form-item label="姓名" prop="customerName">
							<el-input size="small" v-model="formIntention.customerName" type="text" placeholder="请输入姓名"
								style="width: 100%;"></el-input>
						</el-form-item>
						<el-form-item label="意向选择" prop="intention">
							<el-radio-group v-model="formIntention.intention">
								<el-radio v-for="item in optionsIntentionList" :key="item.value" :label="item.value"
									:value="item.value" style="margin: 6px;">{{ item.label }}</el-radio>
							</el-radio-group>
						</el-form-item>
						<el-form-item label="备注">
							<el-input size="small" type="textarea" v-model="formIntention.remark"
								placeholder="请填写该客户通话备注" :autosize="{ minRows: 4, maxRows: 8 }"></el-input>
						</el-form-item>
						<el-form-item style="display: flex;flex-direction: row;justify-content: end;margin-bottom: 0;">
							<el-button type="primary" :class="[theme]" size="small" @click="getblack">加入黑名单</el-button>
							<el-button type="primary" :class="[theme]" size="small"
								@click="openAddReminderModal">添加回访</el-button>
							<el-button type="primary" :class="[theme]" size="small"
								@click="socketForced">强制结束</el-button>
							<el-button type="primary" :class="[theme]" size="small" :disabled="bodadisabled"
								@click="getSocketIntention">上传通话</el-button>
						</el-form-item>
					</el-form>
				</div>
			</div>
		</el-dialog>
		<el-dialog v-model="callPopup5" title="黑名单号码" width="450px" :close-on-click-modal="false">
			<div class="call-type5">
				<div class="black-radio">
					<div class="title">原因</div>
					<el-radio-group v-model="blackremark" @change="blackRadioChange">
						<el-radio label="明确表示不再允许打电话">明确表示不再允许打电话</el-radio>
						<el-radio label="有明显投诉倾向">有明显投诉倾向</el-radio>
						<el-radio label="已确认非目标客户">已确认非目标客户</el-radio>
						<el-radio label="其他">其他</el-radio>
					</el-radio-group>
				</div>
				<div class="btn-box">
					<button @click="callPopup5Close">取消</button>
					<button @click="getblackListAdd">添加</button>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		locale
	} from 'element-plus';
	// 引入 Element Plus 中文语言包
	import zhCn from 'element-plus/es/locale/lang/zh-cn'
	// 引入并设置 Day.js 中文 locale
	import dayjs from 'dayjs'
	import 'dayjs/locale/zh-cn'
	dayjs.locale('zh-cn')
	import axios from 'axios';
	import {
		findCallBack,
		deleteCallBack,
		addCallBack
	} from '../../api/agentIndex.js';
	import {
		fetchDataById,
		socketSend,
		getCallStatuss,
		socketIntention,
		blackListAdd,
		socketforced,
		updateCustomersSchedule,
		intentionCustomercrmCall
	} from '../../api/customerIndex';
	import {
		intentionCustomerList,
		download,
		intentionCustomergetDetails,
		addIntentionCustomer,
		updateIntentionCustomer,
		updateSchedule,
		getfindCallRecord,
		deleteIntentionCustomer,
		GetIntentionCustomeraddJournal,
		downloadIntentionCustomerList,
		turnaroundCustomer,
		removeCrm,
		resetColumn
	} from '../../api/recordIndex';
	import {
		log
	} from '../../api/jssip-3.6.3.js';
	export default {
		name: 'returnVisit',
		data() {
			return {
				value: new Date(),
				theme: localStorage.getItem('theme'),
				theme3: localStorage.getItem('theme3'),
				theme8: localStorage.getItem('theme8'),
				reminders: [],
				showReminderModal: false,
				currentReminder: this.getEmptyReminder(),
				isEditing: false,
				showNotification: false,
				notification: {
					name: '',
					phone: '',
					message: '',
					icon: '',
					type: ''
				},
				currentMonth: '',
				currentYear: '',
				currentTime: '00:00:00',
				timer: null,
				deviceName: null, //是否显示拨打按钮


				formIntention: {
					name: '',
					intention: 'C',
					remark: '',
					id: '',
				},
				callDuration: 0,
				dialogIntention: false,
				optionsIntentionList: [{
						label: '意向强',
						value: 'A',
					},
					{
						label: '意向一般',
						value: 'B',
					},
					{
						label: '无意向',
						value: 'C',
					},
					{
						label: '需再跟进',
						value: 'D',
					},
					{
						label: '无需跟进',
						value: 'E',
					}
				],
				blackremark: '其他',
				callPopup5: false,
			};
		},
		computed: {
			filteredReminders() {
				return [...this.reminders].sort((a, b) => {
					const dateA = new Date(`${a.date} ${a.time}`);
					const dateB = new Date(`${b.date} ${b.time}`);
					return dateA - dateB;
				});
			}
		},
		mounted() {
			this.getFindCallBack();
			this.updateCalendarTitle();
			// 更新当前时间
			this.updateCurrentTime();
			this.timer = setInterval(() => {
				this.updateCurrentTime();
				this.checkReminders();
			}, 1000);
			setInterval(() => {
				this.deviceName = localStorage.getItem('deviceName');
			}, 1000);
		},
		beforeUnmount() {
			if (this.timer) {
				clearInterval(this.timer);
			}
		},
		methods: {
			// 更新当前时间
			updateCurrentTime() {
				const now = new Date();
				const hours = now.getHours().toString().padStart(2, '0');
				const minutes = now.getMinutes().toString().padStart(2, '0');
				const seconds = now.getSeconds().toString().padStart(2, '0');
				this.currentTime = `${hours}:${minutes}:${seconds}`;
			},
			// 更新日历标题（月份和年份）
			updateCalendarTitle() {
				const calendar = this.$refs.calendar;
				if (calendar && calendar.curMonthDate) {
					const currentDate = calendar.curMonthDate;
					this.currentMonth = currentDate.getMonth() + 1 + '月';
					this.currentYear = currentDate.getFullYear();
				} else {
					const today = new Date();
					this.currentMonth = today.getMonth() + 1 + '月';
					this.currentYear = today.getFullYear();
				}
			},
			// 获取空提醒对象
			getEmptyReminder() {
				const now = new Date();
				const hours = now.getHours().toString().padStart(2, '0');
				const minutes = now.getMinutes().toString().padStart(2, '0');
				const seconds = now.getSeconds().toString().padStart(2, '0');
				return {
					id: Date.now(),
					name: '',
					date: this.formatDate(new Date()),
					time: '',
					type: 'work',
					remark: ''
				};
			},
			// 检查是否有提醒
			hasReminders(date) {
				if (!date.date) return false;
				const dateStr = this.formatDate(date.date);
				return this.reminders.some(r => this.formatDate(r.time) === dateStr);
			},
			// 检查是否是今天
			isToday(date) {
				if (!date.date || !(date.date instanceof Date)) return false;
				const today = new Date();
				return date.date.getDate() === today.getDate() &&
					date.date.getMonth() === today.getMonth() &&
					date.date.getFullYear() === today.getFullYear();
			},

			// 格式化日期
			formatDate(date) {
				if (!date) return '';
				// 如果传入的是字符串，尝试转换为日期对象
				if (typeof date === 'string') {
					date = new Date(date);
				}
				// 检查是否为有效日期
				if (!(date instanceof Date) || isNaN(date.getTime())) {
					return '';
				}
				const year = date.getFullYear();
				const month = (date.getMonth() + 1).toString().padStart(2, '0');
				const day = date.getDate().toString().padStart(2, '0');
				return `${year}-${month}-${day}`;
			},
			// 打开添加提醒模态框
			openAddReminderModal(date) {
				this.currentReminder = this.getEmptyReminder();
				if (date) {
					this.currentReminder.date = this.formatDate(date.day);
				}
				this.isEditing = false;
				this.showReminderModal = true;
			},

			// 编辑提醒
			editReminder(reminder) {
				// 将字符串时间转换为时间对象
				const [hours, minutes, seconds] = reminder.time.split(':');
				const time = new Date(0, 0, 0, parseInt(hours), parseInt(minutes), parseInt(seconds));

				this.currentReminder = {
					...reminder,
					time: time
				};
				this.isEditing = true;
				this.showReminderModal = true;
			},

			// 删除提醒
			deleteReminder(id) {
				this.$confirm('确定要删除这个提醒吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					axios.delete('/api/customer/deleteCallBack', {
							params: {
								id: id,
							}
						})
						.then(res => {
							if (res.data.code == 200) {
								window.location.reload();
								this.getFindCallBack()
								this.$message.success(res.data);
							} else {
								this.$message.error(res.data.message);
							}
						})
						.catch(error => console.error('删除失败', error));
				});
			},

			// 保存提醒
			saveReminder() {
				if (!this.currentReminder.phone) {
					this.$message.error('请填写手机号');
					return;
				}
				// 从时间对象提取时间
				if (this.currentReminder.time) {
					const hours = this.currentReminder.time.getHours().toString().padStart(2, '0');
					const minutes = this.currentReminder.time.getMinutes().toString().padStart(2, '0');
					const seconds = this.currentReminder.time.getSeconds().toString().padStart(2, '0');
					this.currentReminder.time = `${hours}:${minutes}:${seconds}`;
				} else {
					this.$message.error('请选择有效的时间');
					return;
				}
				let data = {
					name: this.currentReminder.name,
					phone: this.currentReminder.phone,
					remark: this.currentReminder.remark,
					date: this.formatDate(this.currentReminder.date) + ' ' + this.currentReminder.time,
					userId: localStorage.getItem('user'),
					source: '回访页面'
				}
				addCallBack(data).then(res => {
					if (res?.code === 200) {
						this.showReminderModal = false;
						this.getFindCallBack();
						setTimeout(() => {
							this.showNotification = false;
						}, 3000);
					} else {
						this.$message.error(res.message);
					}
				});
			},

			// 检查提醒
			checkReminders() {
				const now = new Date();
				const currentTimeStr =
					`${now.getHours().toString().padStart(2, '0')}:${now.getMinutes().toString().padStart(2, '0')}:${now.getSeconds().toString().padStart(2, '0')}`;
				const currentDateStr = this.formatDate(now);
				this.reminders.forEach(reminder => {
					if (reminder.time === currentDateStr + ' ' + currentTimeStr) {
						this.triggerAlarm(reminder);
					}
				});
			},

			// 触发提醒
			triggerAlarm(reminder) {
				this.showNotification = true;
				this.notification = {
					name: `姓名：${reminder.name}`,
					phone: `手机号：${reminder.phone}`,
					message: `备注： ${reminder.remark}` || '您有一个提醒事项！',
					icon: 'el-icon-bell',
					type: 'notification-alarm'
				};

				// 播放提示音
				this.playNotificationSound();

			},

			// 播放提示音
			playNotificationSound() {
				const audioContext = new(window.AudioContext || window.webkitAudioContext)();
				const oscillator = audioContext.createOscillator();
				const gainNode = audioContext.createGain();

				oscillator.connect(gainNode);
				gainNode.connect(audioContext.destination);

				oscillator.type = 'sine';
				oscillator.frequency.value = 880;
				gainNode.gain.value = 0.3;

				oscillator.start();
				setTimeout(() => {
					oscillator.stop();
				}, 500);
			},


			closeShowReminderModal() {
				this.showReminderModal = false;
			},
			closeShowNotification() {
				this.showNotification = false;
			},
			getFindCallBack() {
				let data = {
					phone: '',
					userId: localStorage.getItem('user'),
				}
				findCallBack(data).then(res => {
					if (res?.code === 200) {
						this.reminders = res.customData;
					} else {
						this.$message.error(res.message);
					}
				});
			},


			handleSocketSend(row) {
				this.callDuration = 0;
				let username = localStorage.getItem('ms_username');
				this.formIntention.customerName = row.name;
				this.formIntention.id = row.id;
				this.formIntention.remark = row.remark;
				this.phoneNumber = row.phone;
				let data = {
					name: username,
					info: row.phone,
					type: 3,
					filtration: localStorage.getItem('filtration'),
				};
				socketSend(data).then(res => {
					if (res?.code === 200) {
						let a = '与';
						let b = '通话中...';
						if (res.data == 2) {
							this.dialogIntention = true;
							setTimeout(() => {
								this.getCallStatus();
							}, 1000);
							this.timer = setInterval(() => {
								this.callDuration++;
							}, 1000);
						} else if (res.data == 1) {
							this.$message.error('请APP重新进入电脑快拨页面');
							localStorage.removeItem('deviceName');
							setTimeout(() => {
								// window.location.reload();
							}, 2000);
						} else if (res.data == 0) {
							let text = '此号码为“风险号码”，禁止拨打！';
							let msg = this.phoneNumber + text;
							this.$message.error(msg);
							this.getFindCallBack();
						} else if (res.data == 3) {
							let text = '号码已被拉入黑名单,不可拨打';
							let msg = this.phoneNumber + text;
							this.$message.error(msg);
							this.getFindCallBack();
						}
					} else {
						this.bodadisabled = false;
						this.$message.error(res.message);
					}
				});
			},
			getCallStatus() {
				getCallStatuss(localStorage.getItem('ms_username')).then(res => {
					if (res?.code === 200) {
						this.callStatus = res.data.status; //this.callStatus==true  
						if (this.callStatus == true) {
							this.callDuration = res.data.callDuration; //通话时长
							this.clearCurtimer();
						} else {
							setTimeout(() => {
								this.getCallStatus();
							}, 1000);
						}
					} else {
						this.$message.error('请求错误');
					}
				});
			},
			clearCurtimer() {
				if (this.timer) {
					clearInterval(this.timer);
					this.timer = null;
				}
			},
			formatSeconds(result) {
				var h = Math.floor(result / 3600) < 10 ? '0' + Math.floor(result / 3600) : Math.floor(result / 3600);
				var m = Math.floor((result / 60) % 60) < 10 ? '0' + Math.floor((result / 60) % 60) : Math.floor((result /
					60) % 60);
				var s = Math.floor(result % 60) < 10 ? '0' + Math.floor(result % 60) : Math.floor(result % 60);
				if (h > 0) {
					return (result = h + ':' + m + ':' + s);
				} else {
					return (result = m + ':' + s);
				}
			},
			//黑名单选项
			blackRadioChange(evt) {
				this.blackremark = evt;
			},
			getblack() {
				this.blackremark = '其他';
				this.callPopup5 = true;
			},
			gotoCustomerDetail(phone) {
				this.$router.push('/customer?phone=' + phone);
			},
		},
		watch: {
			// 监听日历变化更新标题
			value() {
				this.$nextTick(() => {
					this.updateCalendarTitle();
				});
			}
		}
	};
</script>

<style scoped>
	.container {
		max-width: 1400px;
		margin: 0 auto;
		font-size: 24px;
	}

	.header {
		text-align: center;
		margin-bottom: 30px;
		padding: 20px;
		background: #ffffff;
		border-radius: 12px;
		box-shadow: 0 5px 20px rgba(0, 0, 0, 0.05);

	}

	.header h1 {
		font-size: 36px;
		background: linear-gradient(90deg, #4f7afd, #2ecc71);
		-webkit-background-clip: text;
		background-clip: text;
		color: transparent;
		margin-bottom: 10px;
	}

	.header p {
		font-size: 16px;
		color: #7f8c8d;
		max-width: 800px;
		margin: 0 auto;
		line-height: 1.6;
	}

	.features {
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
		gap: 20px;
		margin: 20px 0;
	}

	.feature {
		background: #e3f2fd;
		padding: 15px 20px;
		border-radius: 10px;
		width: 250px;
		text-align: center;
		transition: transform 0.3s;
	}

	.feature:hover {
		transform: translateY(-5px);
	}

	.feature i {
		font-size: 36px;
		color: #4f7afd;
		margin-bottom: 10px;
	}

	.feature h3 {
		color: #2c3e50;
		margin-bottom: 8px;
	}

	.feature p {
		font-size: 14px;
		color: #7f8c8d;
	}

	.app-container {
		display: flex;
		gap: 30px;
		background: #ffffff;
		border-radius: 12px;
		box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
		overflow: hidden;
		min-height: 700px;
		font-size: 16px;
	}

	.calendar-section {
		flex: 1;
		padding: 25px;
		background: #f9fbfd;
		border-right: 1px solid #eaeef5;
	}

	.reminders-section {
		/* 右边提醒 */
		width: 380px;
		padding: 25px;
		background: #ffffff;
		position: relative;
	}

	.section-title {
		font-size: 16px;
		color: #2c3e50;
		margin-bottom: 20px;
		padding-bottom: 12px;
		border-bottom: 2px solid #4f7afd;
		display: flex;
		align-items: center;
	}

	.section-title i {
		margin-right: 10px;
		color: #4f7afd;
		font-size: 30px;
	}

	/* 日历单元格自定义样式 */
	.custom-cell {
		height: 100%;
		padding: 8px;
		position: relative;
		font-size: 24px;
	}

	.custom-cell .cur-date {
		font-size: 18px;
	}

	.current-day {
		background-color: #4f7afd;
		color: #ffffff;
		border-radius: 50%;
		width: 28px;
		height: 28px;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-bottom: 5px;
	}

	.reminder-indicator {
		position: absolute;
		right: 73.1px;
		top: 42px;
	}

	.reminder-indicator i {
		margin-left: 10px;
		cursor: pointer;
		color: #4f7afd;
		font-size: 22px;
	}

	.add-reminder-btn {
		position: absolute;
		bottom: 20px;
		left: 8px;
		color: #4f7afd;
		cursor: pointer;
		opacity: 0;
		transition: opacity 0.3s;
	}

	.add-reminder-btn i {
		font-size: 24px;
	}

	.custom-cell:hover .add-reminder-btn {
		opacity: 1;
	}

	/* 提醒列表样式 */
	.reminders-list {
		max-height: 600px;
		overflow-y: auto;
		padding-right: 10px;
	}

	.reminder-card {
		background: #f8fafc;
		border-radius: 10px;
		padding: 15px;
		margin-bottom: 15px;
		border-left: 4px solid #4f7afd;
		box-shadow: 0 3px 10px rgba(0, 0, 0, 0.03);
		transition: transform 0.3s, box-shadow 0.3s;
		position: relative;
	}

	.reminder-card:hover {
		transform: translateY(-3px);
		box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
	}

	.reminder-title {
		font-weight: 600;
		font-size: 14px;
		color: #2c3e50;
		margin-bottom: 8px;
	}

	.reminder-time {
		color: #4f7afd;
		font-size: 14px;
		margin-bottom: 10px;
		display: flex;
		align-items: center;
	}

	.reminder-time i {
		font-size: 18px;
		margin-right: 6px;
	}

	.reminder-desc {
		color: #7f8c8d;
		font-size: 14px;
		line-height: 1.5;
	}

	.reminder-date {
		background: #e3f2fd;
		color: #4f7afd;
		font-size: 14px;
		padding: 3px 8px;
		border-radius: 20px;
		display: inline-block;
		margin-top: 10px;
	}

	.reminder-actions {
		position: absolute;
		top: 15px;
		right: 15px;
	}

	.reminder-actions i {
		margin-left: 10px;
		cursor: pointer;
		color: #95a5a6;
		transition: color 0.3s;
		font-size: 22px;
	}

	.reminder-actions i:hover {
		color: #4f7afd;
	}

	.delete-btn:hover {
		color: #e74c3c !important;
	}

	.no-reminders {
		text-align: center;
		padding: 40px 20px;
		color: #95a5a6;
	}

	.no-reminders i {
		font-size: 22px;
		margin-bottom: 20px;
		color: #bdc3c7;
	}

	/* 添加按钮 */
	.add-btn {
		background: #4f7afd;
		color: #ffffff;
		border: none;
		border-radius: 8px;
		padding: 12px 20px;
		font-size: 14px;
		cursor: pointer;
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
		margin-top: 20px;
		transition: background 0.3s;
	}

	.add-btn:hover {
		background: #4f7afd;
	}

	.add-btn i {
		margin-right: 8px;
	}

	/* 响应式设计 */
	@media (max-width: 992px) {
		.app-container {
			flex-direction: column;
		}

		.reminders-section {
			width: 100%;
		}
	}

	/* 自定义日历头部 */
	.calendar-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 20px;
	}

	.calendar-title {
		font-size: 18px;
		font-weight: 600;
		color: #2c3e50;
	}

	.el-calendar__title {
		font-size: 32px;
	}

	.calendar-actions button {
		background: #e3f2fd;
		border: none;
		border-radius: 6px;
		padding: 8px 15px;
		color: #4f7afd;
		cursor: pointer;
		margin-left: 10px;
		transition: background 0.3s;
	}

	.calendar-actions button:hover {
		background: #d1e7fa;
	}

	/* 通知样式 */
	.notification {
		position: fixed;
		top: 20px;
		right: 5px;
		background: #ffffff;
		border-left: 4px solid #2ecc71;
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
		padding: 30px 65px 30px 40px;
		border-radius: 6px;
		z-index: 2000;
		display: flex;
		align-items: center;
		max-width: 350px;
		transform: translateX(120%);
		transition: transform 0.5s ease;
	}

	.notification.show {
		transform: translateX(0);
	}

	.notification i {
		color: #2ecc71;
		font-size: 32px;
		margin-right: 30px;
	}

	.notification-content h4 {
		margin-bottom: 15px;
		color: #2c3e50;
	}

	.notification-content p {
		color: #7f8c8d;
		font-size: 14px;
	}

	.notification-alarm {
		border-left-color: #e74c3c;
	}

	.notification-alarm i {
		color: #e74c3c;
	}

	.reminder-tag {
		display: inline-block;
		padding: 2px 8px;
		border-radius: 4px;
		font-size: 14px;
		margin-right: 5px;
		margin-top: 8px;
	}

	.tag-work {
		background: #e3f2fd;
		color: #4f7afd;
	}

	.tag-personal {
		background: #e8f5e9;
		color: #4caf50;
	}

	.tag-important {
		background: #ffebee;
		color: #e53935;
	}

	.time-picker-container {
		position: relative;
	}

	.time-picker-info {
		position: absolute;
		top: 100%;
		left: 0;
		margin-top: 5px;
		font-size: 14px;
		color: #4f7afd;
	}

	footer {
		text-align: center;
		margin-top: 30px;
		padding: 20px;
		color: #7f8c8d;
		font-size: 14px;
	}

	.system-time {
		position: absolute;
		top: 15px;
		right: 15px;
		background: #e3f2fd;
		padding: 5px 10px;
		border-radius: 20px;
		font-size: 14px;
		color: #4f7afd;
	}

	.instructions {
		background: #e3f2fd;
		border-radius: 10px;
		padding: 20px;
		margin: 20px 0;
	}

	.instructions h3 {
		color: #4f7afd;
		margin-bottom: 10px;
	}

	.instructions ul {
		padding-left: 20px;
	}

	.instructions li {
		margin-bottom: 8px;
		line-height: 1.5;
	}

	.el-dialog .el-dialog__body .dialog-title {
		display: flex !important;
		flex-direction: column !important;
		justify-content: center !important;
		text-align: center !important;
		position: relative !important;
		top: -28px !important;
	}
	
	.el-dialog .el-dialog__body .dialog-title i {
		font-size: 50px !important;
		color: #007bfe !important;
	}
	
	.el-dialog .el-dialog__body .dialog-title .title {
		font-size: 22px;
		font-weight: 500;
		margin: 6px 0;
	}
	
	.el-dialog .el-dialog__body .dialog-title .title img {
		width: 30px;
		height: 30px;
		position: relative;
		top: 6px;
	}
	
	.el-dialog .el-dialog__body .dialog-title .time {
		font-weight: 500;
		font-size: 18px;
		color: #108EE9;
	}
	
	.input-box .el-input__inner {
		height: 50px !important;
		line-height: 50px !important;
		font-size: 24px !important;
		color: #333 !important;
	}
	
	/deep/ .el-dialog {
		margin-top: 2vh !important;
	}
	
	
	
	.call-type5 {
		display: flex;
		flex-direction: column;
		justify-content: flex-end;
	}
	
	.call-type5 .input-box {
		height: 60px;
		border-bottom: 1px solid #ccc;
	}
	
	.call-type5 .black-radio {
		position: relative;
		top: -15px;
		border: 1px solid #4f7afd;
		padding: 10px;
	}
	
	.call-type5 .black-radio .title {
		font-size: 16px;
		color: #606266;
	}
	
	.call-type5 .black-radio .el-radio-group {
		display: flex;
		flex-direction: column;
		margin-top: 10px;
	}
	
	.call-type5 .black-radio .el-radio-group .el-radio {
		margin: 6px 2px;
	}
	
	.call-type5 .btn-box {
		display: flex;
		flex-direction: row;
		justify-content: space-around;
		margin-top: 30px;
	}
	
	.call-type5 .btn-box button {
		width: 84px;
		height: 34px;
		margin: 0;
		padding: 0;
		line-height: 34px;
		text-align: center;
		border-radius: 8px;
		color: #fff;
		font-size: 16px;
		background-color: #007bfe;
		border: none;
	}
	
</style>